import type { StartWithWithoutGeneric } from "@typedefs/modulesInterfaces";
import { FieldType } from "@typedefs/modulesInterfaces";
import { useMemo } from "react";
import { useFetchLucTypesHybrid } from "@app/hooks";
import { BEModulesClassNames } from "@utils/moduleList";

const useLandUseTypeInput = ({ inputName, beModuleClassName }: { inputName: string, beModuleClassName: BEModulesClassNames }) => {

  const { landUseTypes } = useFetchLucTypesHybrid({ className: beModuleClassName })
  const landUseChangeInput: StartWithWithoutGeneric = useMemo(
    () => ({
      type: FieldType.SWW_SELECT,
      inputName: inputName,
      label: "module.type_of_land_use",
      startProps: { dropdownOptions: landUseTypes, disabled: true },
      withProps: { dropdownOptions: landUseTypes, disabled: true },
      withoutProps: { dropdownOptions: landUseTypes, disabled: true },
    }),
    [landUseTypes, inputName],
  );

  return landUseChangeInput
}

export default useLandUseTypeInput